import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import './../../assets/css/CommentModel.css';

class ModalWindow extends React.Component{

     constructor(props) {
        super(props);
        this.state = {
            modal: true,
            message: props.message
        };

        this._toggle = this._toggle.bind(this);
    }



     render() {
        const { className } = this.props;
        const { modal } = this.state;
        const backdrop = this.props.backdrop ? this.props.backdrop : true;
        const size = this.props.size || 'lg';

         return (
           <React.Fragment className='demo'>

            <Modal
              keyboard={true}
              isOpen={modal}
              toggle={this._toggle}
              className={className}
              backdrop={backdrop}
              size={size}
            >

                 <ModalHeader
                toggle={this._toggle}
                  className="modal-header z btn-light mb-4">
                    {this.props.title}
                    </ModalHeader>
                 <ModalBody>
                    {this.props.children}

              </ModalBody>

             </Modal>

           </React.Fragment>


        );
    }

     _toggle() {
        this.setState((prevState) => ({ modal : !prevState.modal }));
        this.props.toggleModal();
    }

}

export default ModalWindow;
